import { ListOrdered, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function QueuePage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Queue</h1>
          <p className="text-sm text-foreground-muted">Manage your print queue and backlog</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add to Queue
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<ListOrdered className="h-10 w-10" />}
          title="No items in queue"
          description="Add items to your print queue to organize your upcoming print jobs."
          actionLabel="Add to Queue"
          onAction={() => {
            // TODO: Open add to queue modal
          }}
        />
      </div>
    </div>
  );
}
